<template>
  <div id="dashboard">
    <h2>Dashboard</h2>
<Button label="Logout" @click="logoutUser()" icon="pi pi-sign-out" iconPos="right" />
  </div>
</template>

<script>
import {fb_auth} from '../firebase'
export default {
  name: 'Dashboard',
  methods: {
      logoutUser() {
        fb_auth.signOut()
        .then(()=> {
          //sign-out successful.
          this.$router.push({path:'/'})
        }).catch(function(error) {
          //an error happened
          console.log(error);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
#dashboard {
  color: #999999;
}

</style>